import React from 'react'
import * as bs4 from 'reactstrap'
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import Navbar from '../../Navbar'
import { ScaleLoader } from 'react-spinners';
import Select from 'react-select';
import Workbook from 'react-excel-workbook'
import CsvParse from '@vtex/react-csv-parse';
import moment from 'moment';
import ReactGA from 'react-ga';
const { proxy } = require('../../../ip_api.config')

class Film_MasterBomLine extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            previewItem: '',
            onPage: 'Preview',
            addData: [],
            arr_temp_edit: [],
            ibrand1: '',
            itemG3: '',
            size: '',
            front_back: '',
            type: '',
            color: '',
            new_bom: '',
            description: '',
            template: [{
                ibrand1: '',
                itemG3: '',
                size: '',
                front_back: '',
                type: '',
                color: '',
                line_num: '',
                new_bom: '',
                qty: '',
                description: '',
            }],
            showUpload: '',
            upload_open: true,
            arr_save: [],
            checkAll: true,
            checked: ''
        }
    }

    componentDidMount() {
        ReactGA.initialize('UA-176717650-5');
        ReactGA.pageview('/flim/MasterBomLine');

        if (localStorage.getItem("ID_User") !== null) {
            this.getOptionBomLine()
        } else {
            this.props.history.push({
                pathname: '/'
            })
        }
    }

    getOptionBomLine = async () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        let arroption_ibrand1 = []
        let arroption_itemG3 = []
        let arroption_size = []
        let arroption_front_back = []
        let arroption_type = []
        let arroption_color = []
        let arroption_new_bom = []
        let arroption_description = []
        let dataWhere = {
            ibrand1: '',
            itemG3: '',
            size: '',
            front_back: '',
            type: '',
            color: '',
            new_bom: '',
            description: '',
        }

        let url = proxy.server + '/flim/getMaster_BomLine'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then(async (responseJson) => {
                // console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {

                    arroption_ibrand1.push(
                        { value: val.ibrand1, label: val.ibrand1 }
                    )

                    arroption_itemG3.push(
                        { value: val.itemG3, label: val.itemG3 }
                    )
                    arroption_size.push(
                        { value: val.size, label: val.size }
                    )
                    arroption_front_back.push(
                        { value: val.front_back, label: val.front_back }
                    )
                    arroption_type.push(
                        { value: val.type, label: val.type }
                    )
                    arroption_color.push(
                        { value: val.color, label: val.color }
                    )
                    arroption_new_bom.push(
                        { value: val.new_bom, label: val.new_bom }
                    )
                    arroption_description.push(
                        { value: val.description, label: val.description }
                    )
                }, this)

                let newArray_ibrand1 = await this.setUniqueArray(arroption_ibrand1)
                let newArray_itemG3 = await this.setUniqueArray(arroption_itemG3)
                let newArray_size = await this.setUniqueArray(arroption_size)
                let newArray_front_back = await this.setUniqueArray(arroption_front_back)
                let newArray_type = await this.setUniqueArray(arroption_type)
                let newArray_color = await this.setUniqueArray(arroption_color)
                let newArray_new_bom = await this.setUniqueArray(arroption_new_bom)
                let newArray_description = await this.setUniqueArray(arroption_description)

                this.setState({
                    option_ibrand1: newArray_ibrand1,
                    option_itemG3: newArray_itemG3,
                    option_size: newArray_size,
                    option_front_back: newArray_front_back,
                    option_type: newArray_type,
                    option_color: newArray_color,
                    option_new_bom: newArray_new_bom,
                    option_description: newArray_description
                }, () => {
                    this.getMasterBomLine()
                })
            })
    }

    setUniqueArray = async (arroption) => new Promise((resolve, reject) => {
        let newArray = [];
        let uniqueObject = {};

        for (let i in arroption) {
            let objTitle = arroption[i]['value'];
            uniqueObject[objTitle] = arroption[i];
        }

        for (let i in uniqueObject) {
            newArray.push(uniqueObject[i]);
        }
        resolve(newArray)
    })

    getMasterBomLine = () => {
        this.setState({ isLoading: true, onPage: 'Preview', checkAll: true })
        const { ibrand1, itemG3, size, front_back, type, color, new_bom, description } = this.state
        let arr = []
        let dataWhere = {
            ibrand1: ibrand1,
            itemG3: itemG3,
            size: size,
            front_back: front_back,
            type: type,
            color: color,
            new_bom: new_bom,
            description: description,
        }
        let url = proxy.server + '/flim/getMaster_BomLine'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push(
                        <tr>
                            <td><bs4.Button color='danger' size='sm' onClick={() => this.Delete_item(val.id)}>DEL</bs4.Button></td>
                            <td>{i + 1}</td>
                            <td>{val.ibrand1}</td>
                            <td>{val.itemG3}</td>
                            <td>{val.size}</td>
                            <td>{val.front_back}</td>
                            <td>{val.type}</td>
                            <td>{val.color}</td>
                            <td>{val.line_num}</td>
                            <td>{val.new_bom}</td>
                            <td>{val.qty}</td>
                            <td>{val.description}</td>
                        </tr>
                    )
                }, this)
                this.setState({
                    previewItem: arr, isLoading: false, result: responseJson.result,
                    arrDataExcel: responseJson.result, filename: 'MasterBomLine' + moment().format('YYYYMMDD')
                })
            })
    }

    getItem_Edit = () => {
        this.setState({ isLoading: true, onPage: 'Edit', showUpload: '' })
        const { ibrand1, itemG3, size, front_back, type, color, new_bom, description } = this.state
        let arr = []
        let dataWhere = {
            ibrand1: ibrand1,
            itemG3: itemG3,
            size: size,
            front_back: front_back,
            type: type,
            color: color,
            new_bom: new_bom,
            description: description,
        }
        let url = proxy.server + '/flim/getMaster_BomLine'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push(
                        <tr>
                            <td style={{ justifyContent: 'center' }}>
                                <bs4.Col>
                                    {
                                        this.state.checked === ''
                                            ? <bs4.Input type="checkbox" style={{ width: 23, height: 23 }}
                                                onChange={(e) => this.checkItem(e.target.checked, val.id)} />
                                            : <bs4.Input type="checkbox" style={{ width: 23, height: 23 }} checked />
                                    }
                                </bs4.Col>
                            </td>
                            <td>{i + 1}</td>
                            <td>{val.ibrand1}</td>
                            <td>{val.itemG3}</td>
                            <td>{val.size}</td>
                            <td>{val.front_back}</td>
                            <td>{val.type}</td>
                            <td>{val.color}</td>
                            <td>{val.line_num}</td>
                            <td>{val.new_bom}</td>
                            <td>{val.qty}</td>
                            <td>{val.description}</td>
                        </tr>
                    )
                }, this)
                this.setState({ previewItem: arr, addData: responseJson.result, isLoading: false })
            })
    }

    checkItem = (check, id) => {
        let data = {}
        if (check === true) {
            data = {
                id: id,
            }
            let arr = this.state.arr_temp_edit.concat(data)
            this.setState({
                arr_temp_edit: arr
            }, () => {
                console.log('arr_temp_edit', this.state.arr_temp_edit)
            })
        } else {
            let arr = this.state.arr_temp_edit

            for (var i = arr.length; i--;) {
                if (arr[i].id === id) arr.splice(i, 1);
            }
            this.setState({
                arr_temp_edit: arr
            }, () => {
                console.log('arr_temp_edit', this.state.arr_temp_edit)
            })
        }
    }

    checkAll = (check) => {
        let arr = []
        let data = ''
        // let data = {}

        if (check) {
            data = 'checked'
            this.state.addData.map(function (val, i) {
                arr.push({
                    id: val.id
                })
            })
        }

        this.setState({
            arr_temp_edit: arr,
            checkAll: !this.state.checkAll,
            checked: data
        }, () => {
            console.log('arr_temp_edit', this.state.arr_temp_edit)
            this.getItem_Edit()
        })
    }


    goto_edit = () => {
        this.props.history.push({
            pathname: '/Flim/editMasterBomline',
            state: { id_edit: this.state.arr_temp_edit }
        })
    }

    addData = () => {
        this.props.history.push({
            pathname: '/Flim/addMasterBomline'
        })
    }

    Delete_item = (id) => {
        if (window.confirm("กรุณายืนยันการลบ")) {
            this.setState({ isLoading: true })
            let url = proxy.server + '/flim/delete_masterBomLine'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify({
                    id: id,
                })
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        this.setState({ isLoading: false }, () => {
                            alert('ลบสำเร็จ')
                            this.getMasterBomLine()
                        })
                    } else {
                        this.setState({ isLoading: false }, () => {
                            alert('ไม่สามารถลบข้อมูลได้ กรุณาตรวจสอบอีกครั้ง')
                        })
                    }
                })
        }
    }

    allData_Preveiw = () => {
        window.location.reload()
    }

    showUpload = () => {
        const keys = [
            'ibrand1', 'itemG3', 'size', 'front_back', 'type', 'color', 'line_num', 'new_bom', 'qty', 'description'
        ]
        if (this.state.upload_open === true) {
            var Upload = <bs4.FormGroup row style={{ marginLeft: '25px', marginBottom: '25px' }}>
                <bs4.Label style={{ color: 'red', marginRight: "20px" }}> **รองรับเฉพาะไฟล์ .csv เท่านั้น</bs4.Label>
                <CsvParse
                    keys={keys}
                    onDataUploaded={(data) => { this.setState({ arr_save: data }) }}
                    onError={this.handleError}
                    render={onChange => <input type="file" onChange={onChange} />
                    }
                />
                <bs4.Button color="success" size="sm" style={{ marginLeft: '20px' }} onClick={this.saveItem}>UPLOAD</bs4.Button>
                <bs4.Button color="warning" size="sm" style={{ marginLeft: '20px' }} onClick={() => { this.setState({ showUpload: '' }) }}>CANCEL</bs4.Button>
            </bs4.FormGroup>
        }

        this.setState({ showUpload: Upload, upload_open: !this.state.upload_open })
    }

    saveItem = () => {
        if (window.confirm("กรุณายืนยันการบันทึก")) {
            let url = proxy.server + '/flim/insert_masterBomline'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify(this.state.arr_save)
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        this.allData_Preveiw()
                    } else {
                        alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                    }
                })
        }
    }

    render() {
        return <div>
            <Navbar nav={'Flim'} menu={'Flim_MasterBomLine'} />
            <div style={{ marginLeft: 20, marginTop: 50, marginRight: 10 }}>
                <bs4.FormGroup row>
                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>ibrand1</bs4.Label>
                    <bs4.Col sm='3'>
                        <Select className="col-md-12"
                            onChange={(e) => this.setState({ ibrand1: e.value })}
                            options={this.state.option_ibrand1}
                            placeholder={'ค้นหา ibrand1'}
                        />
                    </bs4.Col>
                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>itemG3</bs4.Label>
                    <bs4.Col sm='3'>
                        <Select className="col-md-12"
                            onChange={(e) => this.setState({ itemG3: e.value })}
                            options={this.state.option_itemG3}
                            placeholder={'ค้นหา itemG3'}
                        />
                    </bs4.Col>
                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>size</bs4.Label>
                    <bs4.Col sm='3'>
                        <Select className="col-md-12"
                            onChange={(e) => this.setState({ size: e.value })}
                            options={this.state.option_size}
                            placeholder={'ค้นหา size'}
                        />
                    </bs4.Col>
                </bs4.FormGroup>
                <bs4.FormGroup row>
                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>front_back</bs4.Label>
                    <bs4.Col sm='3'>
                        <Select className="col-md-12"
                            onChange={(e) => this.setState({ front_back: e.value })}
                            options={this.state.option_front_back}
                            placeholder={'ค้นหา front_back'}
                        />
                    </bs4.Col>
                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>type</bs4.Label>
                    <bs4.Col sm='3'>
                        <Select className="col-md-12"
                            onChange={(e) => this.setState({ type: e.value })}
                            options={this.state.option_type}
                            placeholder={'ค้นหา type'}
                        />
                    </bs4.Col>
                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>color</bs4.Label>
                    <bs4.Col sm='3'>
                        <Select className="col-md-12"
                            onChange={(e) => this.setState({ color: e.value })}
                            options={this.state.option_color}
                            placeholder={'ค้นหา color'}
                        />
                    </bs4.Col>
                </bs4.FormGroup>
                <bs4.FormGroup row>
                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>new_bom</bs4.Label>
                    <bs4.Col sm='4'>
                        <Select className="col-md-12"
                            onChange={(e) => this.setState({ new_bom: e.value })}
                            options={this.state.option_new_bom}
                            placeholder={'ค้นหา new_bom'}
                        />
                    </bs4.Col>
                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>description</bs4.Label>
                    <bs4.Col sm='4'>
                        <Select className="col-md-12"
                            onChange={(e) => this.setState({ description: e.value })}
                            options={this.state.option_description}
                            placeholder={'ค้นหา description'}
                        />
                    </bs4.Col>
                    <bs4.Button outline color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.getMasterBomLine()}>SEARCH</bs4.Button>
                    <bs4.Button outline style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.allData_Preveiw()}>ดูข้อมูลทั้งหมด</bs4.Button>
                </bs4.FormGroup>
                <bs4.FormGroup row style={{ marginLeft: 10, marginBottom: 20 }}>
                    <bs4.Label style={{ fontSize: 23, fontWeight: 500, marginRight: 10, marginBottom: 20 }}>Master BomLine</bs4.Label>
                    {
                        this.state.onPage === 'Preview'
                            ? <div>
                                <bs4.Button color="success" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.addData()}>ADD DATA</bs4.Button>
                                <bs4.Button color="warning" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.getItem_Edit()}>EDIT</bs4.Button>
                            </div>
                            : <div>
                                <bs4.Button color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.goto_edit()}>GO TO EDIT</bs4.Button>
                                <bs4.Button outline color="warning" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.getMasterBomLine()}>CANCEL</bs4.Button>
                            </div>
                    }
                    <div style={{ justifyContent: 'flex-end' }}>
                        <Workbook filename={this.state.filename + '.xlsx'} element={<bs4.Button outline color="success" style={{ fontWeight: 500, marginRight: 20 }}>EXPORT EXCEL</bs4.Button>} >
                            <Workbook.Sheet data={this.state.arrDataExcel} name="sheet1">
                                <Workbook.Column label="ibrand1" value="ibrand1" />
                                <Workbook.Column label="itemG3" value="itemG3" />
                                <Workbook.Column label="size" value="size" />
                                <Workbook.Column label="front_back" value="front_back" />
                                <Workbook.Column label="type" value="type" />
                                <Workbook.Column label="color" value="color" />
                                <Workbook.Column label="line_num" value="line_num" />
                                <Workbook.Column label="new_bom" value="new_bom" />
                                <Workbook.Column label="qty" value="qty" />
                                <Workbook.Column label="description" value="description" />
                            </Workbook.Sheet>
                        </Workbook>
                        <bs4.Button color="warning" outline style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.showUpload()}>IMPORT</bs4.Button>
                        <Workbook filename={'templateMasterBomLine.xlsx'} element={<bs4.Button color="warning" style={{ fontWeight: 500, marginRight: 20 }}>DOWNLOAD TEMPLATE</bs4.Button>} >
                            <Workbook.Sheet data={this.state.template} name="sheet1">
                                <Workbook.Column label="ibrand1" value="ibrand1" />
                                <Workbook.Column label="itemG3" value="itemG3" />
                                <Workbook.Column label="size" value="size" />
                                <Workbook.Column label="front_back" value="front_back" />
                                <Workbook.Column label="type" value="type" />
                                <Workbook.Column label="color" value="color" />
                                <Workbook.Column label="line_num" value="line_num" />
                                <Workbook.Column label="new_bom" value="new_bom" />
                                <Workbook.Column label="qty" value="qty" />
                                <Workbook.Column label="description" value="description" />
                            </Workbook.Sheet>
                        </Workbook>
                    </div>
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                </bs4.FormGroup>
                {this.state.showUpload}
                <bs4.Table bordered hover>
                    <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                        <tr style={{ textAlign: 'center' }}>
                            <th style={{ backgroundColor: '#fff' }}>
                                {this.state.onPage === 'Edit' && <bs4.Button color="danger" size='sm' onClick={() => this.checkAll(this.state.checkAll)}>ALL</bs4.Button>}
                            </th>
                            <th style={{ backgroundColor: '#fff' }}>ลำดับ</th>
                            <th>ibrand1</th>
                            <th>itemG3</th>
                            <th>size</th>
                            <th>front_back</th>
                            <th>type</th>
                            <th>color</th>
                            <th>line_num</th>
                            <th>new_bom</th>
                            <th>qty</th>
                            <th>description</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.previewItem}
                    </tbody>
                </bs4.Table>
            </div>
        </div >
    }
}

export default Film_MasterBomLine